// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"714":"1cca9f7f","870":"e6f423fb"}[chunkId] + ".chunk.css";
};